import { Injectable } from '@angular/core';
import { GeocodedPlace } from '../../domain/models/geocoded-place.model';
import { NominatimPlaceDto } from '../dtos/nominatim-place.dto';

@Injectable()
export class GeocodedPlaceMapper {
  // Drops results whose coordinates don't parse or fall outside the ranges the backend enforces
  // (DepartmentProfileService.ValidateRange), so an unusable candidate never reaches the picker.
  public toDomainList(dtos: readonly NominatimPlaceDto[]): readonly GeocodedPlace[] {
    return dtos
      .map((dto) => this.toDomain(dto))
      .filter((place): place is GeocodedPlace => place !== null);
  }

  private toDomain(dto: NominatimPlaceDto): GeocodedPlace | null {
    const latitude = Number.parseFloat(dto.lat);
    const longitude = Number.parseFloat(dto.lon);

    if (!Number.isFinite(latitude) || latitude < -90 || latitude > 90) return null;
    if (!Number.isFinite(longitude) || longitude < -180 || longitude > 180) return null;

    return {
      id: String(dto.place_id),
      displayName: dto.display_name,
      latitude,
      longitude,
      houseNumber: dto.address?.house_number ?? null,
    };
  }
}
